import React from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { PersonaLogoCompact } from '@web/ui/icons';

import { SignInWallet } from '../login/SignInWallet';

const ConnectAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('1500')};
  padding: ${({ theme }) => theme.spacing('1500')};
  background: ${({ theme }) => theme.color.surface};
  border-radius: ${({ theme }) => theme.shape.corner['1000']};
`;

const Title = styled.p`
  color: ${({ theme }) => theme.color.onSurface};
  font: ${({ theme }) => theme.typography.brand.bold};
  letter-spacing: ${({ theme }) => theme.typescale.tracking.decreased};
  font-size: ${({ theme }) => theme.typescale.size['6']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.condensed};
`;

const Subtitle = styled.p`
  color: ${({ theme }) => theme.color.onSurfaceVariant};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['0875']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
`;

export const ConnectArea = () => {
  const t = useTranslations();

  return (
    <ConnectAreaContainer>
      <PersonaLogoCompact size="2000" color="onBackground" />
      <Title>{t('SIDE_SHEET-NOT_CONNECTED-TITLE')}</Title>
      <Subtitle>{t('SIDE_SHEET-NOT_CONNECTED-SUBTITLE')}</Subtitle>
      <SignInWallet fullWidth />
    </ConnectAreaContainer>
  );
};
